import useGetApi from 'src/api/useGetApi';

interface RebateAgreementYearsResponse {
  years: number[];
}

const useRebateAgreementYears = () => {
  return useGetApi<RebateAgreementYearsResponse>({
    endpoint: 'rebates/agreements/years',
  });
};

export default useRebateAgreementYears;
export type { RebateAgreementYearsResponse };
